const DEFAULT_API_BASE_URL = process.env.NODE_ENV === "development"
  ? "http://localhost:5500"
  : "https://stage-api.managemysite.org";

export const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE_URL).replace(/\/$/, "");

export const S3_URL =  "https://manage-my-site-assets.s3.ap-south-1.amazonaws.com/"
